import {
  ChangeDetectionStrategy,
  Component,
  input,
  ViewEncapsulation,
} from '@angular/core';

/**
 * An empty state appears when there is no data to display and describes what the user can do next.
 */
@Component({
  selector: 'fmnts-empty-state',
  templateUrl: 'empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'fmnts-empty-state',
    '[class.fmnts-empty-state--white]': 'background() === "white"',
    '[class.fmnts-empty-state--grey]': 'background() === "grey"',
  },
})
export class EmptyStateComponent {
  /**
   * Default type is `transparent`
   */
  readonly background = input<'grey' | 'white' | 'transparent'>('transparent');
}
